export { default as withWidth, isWidthUp, isWidthDown } from '@material-ui/core/withWidth';
